import(/* webpackMode: "eager" */ "/vercel/path0/src/app/kontakt/page.tsx");
